import {useIntl} from 'react-intl'
import BreadCrumb from '../../../_metronic/layout/components/breadcrumb'
import {DashboardStoreMiddle} from './DashboardStoreMiddle'

export default function DashboardPage() {
  const intl = useIntl()

  return (
    <div>
      <div className='d-flex justify-content-between align-items-center'>
        <BreadCrumb currentPage={intl.formatMessage({id: 'DASHBOARD'})} />
      </div>

      <div className='mt-5'>
        <DashboardStoreMiddle />
      </div>
    </div>
  )
}
